
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 23.93 23.99"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Layer 2"}},[_c('path',{attrs:{"d":"M21.68 10.74h-2.79V7.95a2.25 2.25 0 00-2.25-2.25h-3.39V2.25A2.25 2.25 0 0011 0H2.25A2.25 2.25 0 000 2.25V11a2.25 2.25 0 002.25 2.25h3.43v3.49a2.25 2.25 0 002.21 2.21h2.75v2.75a2.25 2.25 0 002.25 2.25h8.75a2.25 2.25 0 002.25-2.21v-8.79a2.25 2.25 0 00-2.21-2.21zm-16-2.79v3.3H2.25A.25.25 0 012 11V2.25A.25.25 0 012.25 2H11a.25.25 0 01.25.25v3.49H7.89a2.25 2.25 0 00-2.21 2.21zm5 5v4H7.89a.25.25 0 01-.25-.25V7.95a.25.25 0 01.25-.21h8.75a.25.25 0 01.25.21v2.75h-4a2.25 2.25 0 00-2.21 2.25zm11.21 8.79a.25.25 0 01-.25.25h-8.75a.25.25 0 01-.25-.25v-8.79a.25.25 0 01.25-.25h8.75a.25.25 0 01.25.25z","fill":"#afb0bf","data-name":"Layer 1"}})])])
          )
        }
      }
    